<div
  [ngClass]="dense ? ['stack-space-2xs', 'max-w-xs'] : ['stack-space-s', 'max-w-s']"
  class="[ stack surface items-center justify-center ] [ w-full m-auto text-center p-m corner-m ]"
  >
  @if (svgIcon) {
    <dcr-icon class="campus-icon [ h-auto w-full ]" [attr.icon]="svgIcon"></dcr-icon>
  }
  @if (svgImage && !svgIcon) {
    <campus-svg class="[ h-auto w-full ]" [svgImage]="svgImage"></campus-svg>
  }

  @if (title) {
    <div [ngClass]="dense ? ['title-small'] : ['title-medium']">{{ title }}</div>
  }

  @if (description) {
    <div
      [ngClass]="dense ? ['label-small'] : ['label-medium']"
      class="[ on-surface text-opacity-medium ]"
      [innerHTML]="description"
    ></div>
  }

  @if (showCta && ctaLabel) {
    <button
      [disabled]="disabled"
      filled-button
      data-cy="btn-empty-state"
      (click)="ctaClick()"
      [leadingIcon]="ctaIcon"
      >
      {{ ctaLabel }}
    </button>
  }
</div>
